<div class="container-fluid d-flex flex-column h-100 pb-3">
  <div class="page-head">
    <h1 class="page-title">Admin - Spotlight Vendors</h1>
    <div class="action-row">
      <button class="btn btn-primary" (click)="addRank()">
        Add vendor rank
      </button>
    </div>
  </div>

  <div class="row flex-grow-1">
    <div class="col">
      <app-company-service-rankings-grid
        [gridName]="'ClientSpotlightVendors'"
        [suppliedQueryData]="suppliedGridQueryData"
        [ColumnIdToColumnActions]="ColumnIdToColumnActions"
        [(reloadGridData)]="reloadGrid"
        (actionEvent)="action($event)"
      ></app-company-service-rankings-grid>
    </div>
  </div>
</div>
